import React, { useMemo, useState } from "react";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { TEMPLATE_OPTIONS } from "./constants";
import { TemplateOptionValue } from "./types";
import NoTranslate from "../../../../atoms/NoTranslate";

type TemplateDropdownProps = {
  value?: TemplateOptionValue;
  onChange: (value: TemplateOptionValue) => void;
};

const TemplateDropdown: React.FC<TemplateDropdownProps> = ({
  value = "old",
  onChange,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const selectedLabel = useMemo(() => {
    return (
      TEMPLATE_OPTIONS.find((option) => option.value === value)?.label ||
      t("dashboard.entities.viewEntityUser.sendMsg.defaultTemplate")
    );
  }, [value, t]);

  const handleSelect = (optionValue: TemplateOptionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full">
      <button
        type="button"
        className="flex w-full items-center justify-between rounded-md border border-gray-300 px-4 py-2 text-left text-sm font-medium text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <NoTranslate>{selectedLabel}</NoTranslate>
        {isOpen ? <BiChevronUp size={20} /> : <BiChevronDown size={20} />}
      </button>

      {isOpen && (
        <div className="absolute left-0 top-full z-50 mt-2 w-full rounded-md border border-gray-300 bg-white shadow-sm">
          <ul className="p-2 bg-white rounded-md shadow-sm">
            {TEMPLATE_OPTIONS.map((option) => (
              <li
                key={option.value}
                className="flex cursor-pointer items-center justify-between rounded px-4 py-2 text-sm hover:bg-gray-100"
                onClick={() => handleSelect(option.value)}
              >
                <NoTranslate>{option.label}</NoTranslate>
                {option.icon && (
                  <img
                    alt={option.label}
                    className="h-6 w-6"
                    src={option.icon}
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TemplateDropdown;
